<!--
 * @Author: niuziji 18752021112@163.com
 * @Date: 2022-12-07 15:10:11
 * @LastEditors: niuziji 18752021112@163.com
 * @LastEditTime: 2022-12-15 18:16:44
 * @FilePath: \yl-wxcx-coupon-front\src\views\xmas\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="contailner">
    <img src="https://ocms.jtexpress.com.cn/baw/applets/auto/xmas-active.jpg" alt="" style="width: 100%;position: absolute;top: 0;left:0;opacity: 0;z-index: -999;">
    <div class="header" :style="{backgroundImage: 'url(' + bannerImg + ')'}"></div>
    <div class="content" :style="{backgroundImage: 'url(' + formImg + ')'}">
      <div class="form-info">
        <a-form-model :form="formData" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-model-item class="width50">
            <a-input v-model.trim="formData.name" :maxLength="30" placeholder="姓名"></a-input>
          </a-form-model-item>
          <a-form-model-item class="width50">
            <a-input v-model.trim="formData.mobile" :maxLength="14" placeholder="手机或固定电话"></a-input>
          </a-form-model-item>
          <div @click="showAddressSelect=true" class="position-ssq">
            <a-form-model-item prop="positionSSQ" class="input-info">
              <a-input v-model="formData.positionSSQ" placeholder="请选择省市区" readOnly :maxLength="200" prefix-icon="nameImg">
                <div class="img-suffix" slot="suffix">
                  <img :src="arrowRight" class="input_icon dizhi" alt="">
                </div>
              </a-input>
            </a-form-model-item>
          </div>
          <a-form-model-item class="width50" prop="addressDetail">
            <a-input v-model.trim="formData.address" :maxLength="255" placeholder="详细地址"></a-input>
          </a-form-model-item>
          <div class="footer">
            <a-form-model-item>
              <a-checkbox v-model="checkFlag" @change="checkChange"></a-checkbox>
              <span class="tips-info">
                为了确认报名及抽奖信息, 您勾选即代表同意我们收集您填入的姓名、电话、地址等信息。我们仅在前述目的及法规要求的时效内使用、保留前述信息。
              </span>
            </a-form-model-item>
            <a-form-model-item>
              <a-button :class="[checkFlag && 'red-btn', 'gray-btn']" type="primary" :loading="loading" @click="handleSubmit">
                提交
              </a-button>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </div>
    <div class="footer">
      <img :src="footerImg" alt="">
    </div>
    <van-popup v-model="showAddressSelect" position="bottom" :style="{height: '40%'}">
      <div style="position: relative;">
        <van-tabs v-model="tabActive" swipeable>
          <van-tab title="省">
            <div class="area-container">
              <div v-if="provinceList.length > 0">
                <div class="item-container"
                     :class="{'active': index === provinceIndex}"
                     v-for="(item, index) in provinceList" :key="index"
                     @click="handleSelected(item, index, 1)">
                  {{ item.nativeName }}
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="市">
            <div class="area-container">
              <div v-if="cityList.length > 0 && tabActive === 1">
                <div class="item-container"
                     :class="{'active': index === cityIndex}"
                     v-for="(item, index) in cityList" :key="index"
                     @click="handleSelected(item, index, 2)">
                  {{ item.nativeName }}
                </div>
              </div>
              <div v-else class="empty">暂无数据</div>
            </div>
          </van-tab>
          <van-tab title="区">
            <div class="area-container">
              <div v-if="countyList.length > 0 && tabActive === 2">
                <div class="item-container"
                     :class="{'active': index === countyIndex}"
                     v-for="(item, index) in countyList" :key="index"
                     @click="handleSelected(item, index, 3)">
                  {{ item.nativeName }}
                </div>
              </div>
              <div v-else class="empty">暂无数据</div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
  </div>
</template>

<script>
const arrowRight = require('@/assets/img/xmas/arrow-right.png')
// 固话
const fixedTelephone = /^\d{3,4}-\d{7,8}$/
// 手机号码
const telRule = /^1[3456789]\d{9}$/
// 6到13位的固定电话
const reg512 = /^(0|[2-9])\d{5,12}$/
import { RESPONSE_SUCCESS, XMAS_CODE } from '@constants'
import { receiveBenefit, getAppletParams } from '@/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'Xmas',
  metaInfo() {
    return {
      title: '极兔欢乐送大挑战',
      meta: [
        { name: 'description', content: '大型现实版连连看，等你挑战赢奖励' },
        {
          property: 'og:title',
          content: '极兔欢乐送大挑战',
          vmid: 'og:title',
        },
        {
          property: 'og:description',
          content: '大型现实版连连看，等你挑战赢奖励',
          vmid: 'og:description',
        },
      ],
    }
  },
  data() {
    return {
      arrowRight,
      bannerImg: '',
      formImg: '',
      footerImg: '',
      showAddressSelect: false,
      tabActive: 0,
      provinceIndex: '', // 选中的省份索引
      cityIndex: '', // 选中的城市索引
      countyIndex: '', // 选中的地区索引
      areaObj: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        countyId: '',
        countyName: '',
      },
      formData: {
        name: '',
        mobile: '',
        positionSSQ: '',
        provinceName: '', // 省
        provinceId: '',
        cityName: '', // 市
        cityId: '',
        areaName: '',
        areaId: '',
        address: '',
      },
      provinceList: [],
      cityList: [],
      countyList: [],
      loading: false,
      checkFlag: false,
    }
  },
  async created() {
    this.getImgList(88)
    this.getImgList(87)
    this.getImgList(86)
    this.getAddressList(2, 1)
    this.immediateCouponCollection()
  },
  methods: {
    async immediateCouponCollection () {
      const env = this.get_env() // 当前环境域名
      const WX_IMG_URL = 'https://ocms.jtexpress.com.cn/baw/applets/auto/xmas-active.jpg'
      const WX_Title = '极兔欢乐送大挑战' // 微信分享标题
      const WX_DES = '大型现实版连连看，等你挑战赢奖励' // 微信分享描述
      const WX_LINK = `${env}/Xmas`
      const { code, data } = await getAppletParams.getAppletParams(WX_LINK)
      if (code === 1) {
        wx.config({
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
          openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          wx.updateAppMessageShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
            success: function () {
              console.log();('成功updateAppMessageShareData')
            },
          })
        })

        wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
            success: function () {
              console.log();('成功updateTimelineShareData')
            },
          })
        })

        // 通过error接口处理失败验证
        wx.error(function (res) {
          console.log(res, '通过error接口处理失败验证')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        })
      }
    },
    get_env () { // 根据环境设置地址
      let env = ''
      switch (process.env.VUE_APP_ENV) {
        case 'prod':
          env = 'https://coupon.jtexpress.com.cn'
          break
        case 'uat':
          env = 'https://uat-coupon.jtexpress.com.cn'
          break
        case 'development':
          env = 'http://test-coupon.jms.com'
          break
        default:
          env = 'https://coupon.jtexpress.com.cn'
          break
      }
      return env
    },
    async getImgList(type) {
      const params = {
        type,
      }
      const { code, data } = await receiveBenefit.getImgList(params)
      if (code === RESPONSE_SUCCESS) {
        switch (type) {
          case 88:
            this.bannerImg = data && data[0].imageUrl
            break
          case 87:
            this.formImg = data && data[0].imageUrl
            break
          case 86:
            this.footerImg = data && data[0].imageUrl
            break
          default:
            break
        }
      }
    },
    /**
     * 普通选择器逻辑
     * @param type
     * @param parentId
     * @returns {Promise<void>}
     */
    async getAddressList(type, parentId) {
      const params = {
        type,
        parentId,
        addressType: 1,
      }
      const { code, data } = await receiveBenefit.getAddressList(params)
      if (code === RESPONSE_SUCCESS) {
        if (type === 2) {
          this.provinceList = data
        } else if (type === 3) {
          this.cityList = data
        } else if (type === 4) {
          this.countyList = data
        }
      }
    },
    async handleSelected(item, index, type) {
      if (type === 1) {
        this.provinceIndex = index
        this.areaObj.provinceId = item.id
        this.areaObj.provinceName = item.nativeName
        await this.getAddressList(3, item.id)
        this.provinceIndex = ''
        this.cityIndex = ''
        this.countyIndex = ''
        this.tabActive = 1
      }
      if (type === 2) {
        this.cityIndex = index
        this.areaObj.cityId = item.id
        this.areaObj.cityName = item.nativeName
        await this.getAddressList(4, item.id)
        this.tabActive = 2
      } else if (type === 3) {
        this.countyIndex = index

        this.formData.provinceId = this.areaObj.provinceId
        this.formData.provinceName = this.areaObj.provinceName
        this.formData.cityId = this.areaObj.cityId
        this.formData.cityName = this.areaObj.cityName
        this.formData.areaId = item.id
        this.formData.areaName = item.nativeName
        this.showAddressSelect = false
        this.formData.positionSSQ = `${this.formData.provinceName} / ${this.formData.cityName} / ${this.formData.areaName}`
      }
    },
    async handleSubmit() {
      if (!this.checkFlag) {
        return
      }
      const { name, mobile, positionSSQ, address } = this.formData
      if (!name) {
        return this.toast('fail', '姓名不能为空')
      }
      if (!mobile) {
        return this.toast('fail', '手机或固定电话不能为空')
      }
      if (
        !telRule.test(String(mobile).trim()) &&
        !fixedTelephone.test(String(mobile).trim()) &&
        !reg512.test(String(mobile).trim())
      ) {
        return this.toast('fail', '手机号有误')
      }
      if (!positionSSQ) {
        return this.toast('fail', '省市区不能为空')
      }
      if (!address) {
        return this.toast('fail', '详细地址不能为空')
      }
      // debugger
      const times = new Date().valueOf()
      const sign = this.$md5(this.$md5(times + XMAS_CODE))
      const params = {
        times,
        sign,
        ...this.formData,
      }
      const { code, msg } = await receiveBenefit.christmasRegistrationActivity(params)
      if (code === RESPONSE_SUCCESS) {
        this.toast('success', '报名成功')
        this.resetData()
      } else {
        this.toast('fail', msg)
      }
    },
    toast(type, msg) {
      this.$toast({
        type,
        message: msg,
        duration: 2000,
      })
    },
    resetData() {
      this.formData.name = ''
      this.formData.mobile = ''
      this.formData.positionSSQ = ''
      this.formData.provinceName = ''
      this.formData.provinceId = ''
      this.formData.cityName = ''
      this.formData.cityId = ''
      this.formData.areaName = ''
      this.formData.areaId = ''
      this.formData.address = ''
      this.provinceIndex = ''
      this.cityIndex = ''
      this.countyIndex = ''
      this.tabActive = 0
      this.checkFlag = false
    },
    checkChange(e) {
      this.checkFlag = e.target.checked
    },
  },
}
</script>

<style lang="scss" scoped>
.contailner {
  width: 100%;

  .header {
    width: 100%;
    height: 1284rpx;
    // background-image: url('../../assets/img/xmas/header-banner.png');
    background-size: cover;
  }

  .content {
    width: 100%;
    height: 1000rpx;
    background-image: url('../../assets/img/xmas/content.png');
    background-size: cover;
    position: relative;
    padding-top: 320rpx;

    .width50, .input-info {
      margin: 0;
      padding: 0 50px;
    }

    ::v-deep {
      .ant-form-item-children {
        display: flex;
      }
      .ant-checkbox-wrapper {
        line-height: 1.2;
      }

      .ant-checkbox-checked .ant-checkbox-inner::after {
        border: 2px solid red;
        border-top: 0;
        border-left: 0;
      }

      .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: #666666;
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #ffffff;
        border-color: #666666;
      }

      .ant-checkbox-checked::after {
        border: 1px solid #666666;
      }
    }

    .tips-info {
      display: inline-block;
      margin-left: 4rpx;
      font-size: 24rpx;
      line-height: 28rpx;
      color: #666666;
    }

    .form-info {
      ::v-deep {
        .ant-input {
          height: 96rpx;
          border: none;
          border-bottom: 1px solid #bcbcbc;
          border-radius: inherit;
          background: #f6f6f6;
        }

        .ant-input-suffix {
          position: relative;
          .img-suffix {
            position: absolute;
            right: -20rpx;
            top: -120rpx;
            transform: rotate(90deg);
          }
        }

        .ant-input-affix-wrapper {
          border-color: #EE0201;
        }
        .ant-input-affix-wrapper:hover {
          border-color: #EE0201;
        }
        .ant-input:hover {
          border-color: #EE0201;
        }
        .ant-input:focus {
          border-color: #EE0201;
        }
        .ant-input:hover {
          border-color: #bcbcbc;
        }
        .ant-input:focus {
          box-shadow: none;
        }
      }
    }

    .img-suffix {
      img {
        height: 30rpx;
      }
    }

    .footer {
      margin-top: 36rpx;
      padding: 0 70rpx;

      .gray-btn {
        width: 100%;
        height: 96rpx;
        background: #cccccc;
        border-color: #cccccc;
      }
      .ant-form-item {
        margin-bottom: 30rpx;
      }

      .red-btn {
        width: 100%;
        height: 96rpx;
        background: #E60000;
        border-color: #E60000;
      }
    }
  }

  .area-container{
    height: 500rpx;
    overflow: auto;

    .item-container {
      padding: 25rpx 20rpx;
      font-size: 26rpx;
      font-weight: 400;
      color: #666666;
      border-top: 1px solid #eeeeee;
      text-align: center;

      &.active {
        color: #e60000;
      }
    }

    .empty {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #cccccc;
    }
  }

  .footer {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>
